export var GraphicsType;
(function (GraphicsType) {
    /**
     * 用户图库
     */
    GraphicsType[GraphicsType["user"] = 0] = "user";
    /**
     * 系统图库
     */
    GraphicsType[GraphicsType["system"] = 1] = "system";
    /**
   * 当前图库
   */
    GraphicsType[GraphicsType["current"] = 2] = "current";
})(GraphicsType || (GraphicsType = {}));
